import { LatestRequests } from './components/LatestRequests';

const Attendance: React.FC = () => {
  return <LatestRequests />;
};

export default Attendance;
